import React from "react";
import { useFeatureFlag } from "../../../hooks/useFeatureFlag/useFeatureFlag";
import { Flags } from "../../../feature-flags/flags";

export const Error404 = () => {
    const { enabled: enableRebrand } = useFeatureFlag(Flags.ENABLE_REBRAND);
    return <opti-error-404 {...(enableRebrand && { version: "2" })}></opti-error-404>;
};

Error404.displayName = "Error404";
